import { Building2, KeyRound as Keys, Home, Shield, Store, Landmark } from "lucide-react";
import Reveal from "./Reveal";

// Partenaires B2B imaginés — noms génériques, non identifiables à des marques réelles
const PARTNERS = [
  { name: "Franciliens Immo",   mono: "F", color: "#1D4ED8" }, // bleu
  { name: "Habitat & Cie",       mono: "H", color: "#059669" }, // vert
  { name: "Copro Partners",      mono: "C", color: "#DC2626" }, // rouge
  { name: "Syndic AXIOME",       mono: "A", color: "#7C3AED" }, // violet
  { name: "Immo Grand Paris",    mono: "I", color: "#EA580C" }, // orange
  { name: "Résidences 92",       mono: "R", color: "#0891B2" }, // cyan
  { name: "Gérance Paris Est",   mono: "G", color: "#DB2777" }, // rose
  { name: "Habitation IDF",      mono: "H", color: "#4F46E5" }, // indigo
];

const CLIENT_TYPES = [
  { Icon: Building2, t: "Syndics de copropriété",  d: "Interventions récurrentes sur immeubles collectifs, colonnes montantes, parties communes." },
  { Icon: Home,      t: "Agences immobilières",    d: "Remises en état locative, sinistres, diagnostics, dépannages urgents locataires." },
  { Icon: Keys,      t: "Bailleurs sociaux",       d: "Contrats-cadres, interventions dans le patrimoine social francilien, sécurisation." },
  { Icon: Shield,    t: "Assurances habitation",   d: "Interventions sur mandat d'expertise, rapports détaillés, prise en charge sinistre." },
  { Icon: Store,     t: "Commerçants & pro.",      d: "Restaurants, boutiques, cabinets libéraux : dépannage rapide, disponibilité étendue." },
  { Icon: Landmark,  t: "Collectivités & institutions", d: "Écoles, structures publiques, EHPAD — interventions coordonnées avec les services techniques." },
];

const STATS = [
  { n: "50+",    l: "Syndics partenaires en Île-de-France" },
  { n: "800+",   l: "Immeubles suivis régulièrement" },
  { n: "12 000", l: "Interventions par an" },
  { n: "4,9/5",  l: "Note moyenne clients (Google)" },
];

export default function Partners({ deptLabel }) {
  return (
    <section data-testid="partners-section" className="py-16 md:py-20 bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="overline">Ils nous font confiance</span>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-4xl">
              Syndics, agences et bailleurs {deptLabel ? `${deptLabel} ` : ""}nous confient leurs dépannages
            </h2>
            <p className="mt-4 text-ink-soft leading-relaxed">
              Depuis plus de dix ans, Le Bon Dépanneur intervient au quotidien pour des professionnels de l&apos;immobilier
              qui exigent réactivité, transparence tarifaire et qualité de finition. Une relation de confiance
              construite intervention après intervention.
            </p>
          </div>
        </Reveal>

        {/* Logos "partenaires" */}
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
          {PARTNERS.map((p) => (
            <div
              key={p.name}
              className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50/50 px-4 py-3 hover:bg-white hover:border-slate-300 transition-colors"
            >
              <span
                className="h-9 w-9 rounded-lg flex items-center justify-center text-white font-display font-black text-lg shrink-0"
                style={{ backgroundColor: p.color }}
              >
                {p.mono}
              </span>
              <span className="font-display font-semibold text-ink text-sm leading-tight">{p.name}</span>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {STATS.map((s) => (
            <Reveal key={s.l}>
              <div className="rounded-2xl bg-gradient-to-br from-slate-900 to-slate-800 text-white p-6 text-center">
                <p className="font-display font-black text-3xl md:text-4xl">{s.n}</p>
                <p className="mt-2 text-white/70 text-sm leading-tight">{s.l}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Client types */}
        <div className="mt-14">
          <h3 className="text-center font-display font-extrabold text-ink text-2xl md:text-3xl">
            Nos types de clients
          </h3>
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CLIENT_TYPES.map((c, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="card-soft p-6 h-full hover:translate-y-0">
                  <span className="h-11 w-11 rounded-xl bg-brand/10 flex items-center justify-center">
                    <c.Icon className="h-5 w-5 text-brand" />
                  </span>
                  <h4 className="font-display font-bold text-ink mt-4">{c.t}</h4>
                  <p className="text-ink-soft text-sm mt-2 leading-relaxed">{c.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
